module.exports = __webpack_public_path__ + "media/_/_/engines/accounts/app/javascript/images/ep-mountains-a397e670fb82933fc95970125b31d7a9.png";